module.exports = __webpack_public_path__ + "img/historyBlue.2dd08c57.svg";